import localStorageHelper from '@/assets/modules/localStorageHelper'
import gql from 'graphql-tag'
import base from '@/mixins/pagination/base'

const ADVERTISABLE_BODY = `
  id,
  url,
  type,
  label,

  media {
    set {
      url
    }
  }

  meta {
    ... on AdvertisableImportedProduct {
      description,
      vendor,
      price,
      discount,
      tags
    }
    ... on AdvertisableProduct {
      price,
      discount,
      description
      discountValidity
    }
    ... on AdvertisablePost {
      description: content,
      tags
    }
  }
`

export default {
  data () {
    return {
      usingSearchQuery: false,

      advertisables: {},
      searchedAdvertisables: {},
      advertisableMeta: {},
      filterFields: {}
    }
  },

  methods: {
    refetch () {
      this.$apollo.queries.advertisables.refetch()
      this.$apollo.queries.searchedAdvertisables.refetch()
    },

    useSearchQuery () {
      this.usingSearchQuery = true
      this.$apollo.queries.advertisables.skip = true
      this.$apollo.queries.searchedAdvertisables.skip = false
      this.refetch()
    },

    useNormalQuery () {
      this.usingSearchQuery = false
      this.$apollo.queries.advertisables.skip = false
      this.$apollo.queries.searchedAdvertisables.skip = true
      this.refetch()
    },

    /**
     * Updates advertisable filter fields
     * @param {Object} e
     */
    updateFilter (e) {
      if (e.value) {
        this.$set(this.filterFields, e.input, e.value)
      } else {
        this.$delete(this.filterFields, e.input)
      }
    }
  },

  computed: {
    getDataSet () {
      // If using the search
      if (this.usingSearchQuery) {
        return this.searchedAdvertisables.set
      } else {
        return this.advertisables.set
      }
    },

    getData () {
      return this.getDataSet
    },

    getPaginationParams () {
      if (this.usingSearchQuery) {
        return this.searchedAdvertisables.info || {}
      } else {
        return this.advertisables.info || {}
      }
    },

    /**
     * Gives filter fields -- used by mixin
     * @returns {Object}
     */
    getFilterFields () {
      return this.filterFields
    },

    /**
     * Gives advertisable filters used by query
     * @returns {Object}
     */
    advertisableFilters () {
      return Object.assign(
        {},
        // Component's filters
        this.getFilterFields,
        // Limit & offset
        {
          limit: this.getLimit || 1,
          offset: this.getOffset || 0
        }
      )
    },

    /**
     * Gives advertisable's categories
     * @returns {Arrau}
     */
    getAdvertisableCategories () {
      let credentials = ((this.advertisableMeta.credentials || {}).set) || []
      // Filter out credentials with no categories...
      return (credentials.filter(c => (c.meta || {}).categories)
        // Push all credentials to same array
        .reduce((prev, cur) => {
          // Change object structure
          let current = cur.meta.categories.map(c => { return { label: c.name, val: c.name } })
          return prev.concat(current)
        }, []))
    }
  },

  mixins: [
    base
  ],

  watch: {
    filterFields: {
      handler: function(newValue) {
        if (Object.keys(this.filterFields).length) {
          this.useSearchQuery()
        } else {
          this.useNormalQuery()
        }
      },
      deep: true
    }
  },

  // Apollo...
  apollo: {
    advertisables: {
      query: gql`query ($uid: [UUID!], $limit: Int!, $offset: Int!) {
        advertisables(ownedBy: $uid, limit: $limit, offset: $offset) {
          info {
            total
          },
          set {
            ${ADVERTISABLE_BODY}
          }
        }
      }`,
      variables () {
        return {
          uid: localStorageHelper.getData('user', 'id'),
          limit: this.getLimit || 1,
          offset: this.getOffset || 0
        }
      },
      skip: () => false,
      fetchPolicy: 'cache-and-network'
    },

    searchedAdvertisables: {
      query: gql`query ($query: String!, $limit: Int!, $offset: Int!, $tag: String!, $category: String!) {
        searchedAdvertisables: searchAdvertisables (query: $query, limit: $limit, offset: $offset, tag: $tag, category: $category) {
          info {
            total
          },
          
          set {
            ${ADVERTISABLE_BODY}
          }
        }
      }`,
      variables () {
        return this.advertisableFilters
      },
      skip: () => true,
      fetchPolicy: 'cache-and-network'
    },

    advertisableMeta: {
      query: gql`query {
        advertisableMeta: user {
          id,
          credentials {
            set {
              id,
              meta {
                ... on UserCredentialsShopamineShop {
                  categories {id, name}
                }
                ... on UserCredentialsWooCommerceShop {
                  categories {id, name}
                }
                ... on UserCredentialsShopifyShop {
                  categories {id, name}
                }
              }
            }
          }
        }
      }`,
      fetchPolicy: 'cache-and-network'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/advertisables.js